import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home' // 首页

import Login from '@/views/Login/Login' // 登录
import carsilogin from '@/views/Login/carsiLogin' // carsi校验登录
import zglsLogin from '@/views/Login/zglsLogin' // 中共崂山区委党校图书馆登录
import authVerify from '@/views/Login/authVerify'//统一身份认证
import outPage from '@/views/outPage'; // 登录



// if (sessionStorage.getItem('token')) {
//     store.commit('set_token', sessionStorage.getItem('token'))
//     }


Vue.use(Router)

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    // mode:'history',
    routes: [
        // 登录
        { path: "/", name: "Login", component: Login },
        { path: "/zglsLogin", name: "zglsLogin", component: zglsLogin },
        { path: "/authVerify", name: "authVerify", component: authVerify }, //鄂州职业大学统一身份认证
        { path: "/carsilogin", name: "carsilogin", component: carsilogin },
        { path: "/outPage", name: "outPage", component: outPage },
        {
            path: '/home', name: 'Home', redirect: '/home/homePage', component: Home, children: [
                {
                    path: 'homePage', name: 'HomePage', meta: { requireAuth: true, }, component: () => import('../views/HomePage.vue'),
                },
                {
                    path: "myOrder", name: "myOrder", meta: { requireAuth: true, }, component: () => import('../views/myOrder.vue'),
                },
                // {
                //     path: "searchBookByClassify", name: "searchBookByClassify", meta: { requireAuth: true, }, component: () => import('../views/searchBookByClassify.vue'),
                // },
                //试读
                {
                    path: "tryReadeBook", name: "tryReadeBook", meta: { requireAuth: true, }, component: () => import('../views/tryReadeBook.vue'),
                },
                //院系分类
                {
                    path: "departmentClassify", name: "departmentClassify", meta: { requireAuth: true, }, component: () => import('../views/departmentClassify.vue'),
                },
                //出版社专题
                {
                    path: "publicTheme", name: "publicTheme", meta: { requireAuth: true, }, component: () => import('../views/publicTheme.vue'),
                },
                {
                    path: "ztfLibrary", name: "ztfLibrary", meta: { requireAuth: true }, component: () => import('../views/ztfLibrary.vue'),
                },
                // {
                //     path: "libraryBookByClassify", name: "libraryBookByClassify", component: () => import('../views/libraryBookByClassify.vue')
                // },
                {
                    path: "libraryResources", name: "libraryResources", component: () => import('../views/libraryResources.vue')
                },
                {
                    path: "bookDetails", name: "bookDetails", component: () => import('../views/bookDetails.vue')
                },
                {
                    path: "searchResultsBook", name: "searchResultsBook", component: () => import('../views/searchResultsBook.vue')
                },
                {
                    path: "HighSearch", name: "HighSearch", component: () => import('../views/HighSearch.vue')
                },
                {//有声读物
                    path: "youSheng", name: "youSheng", component: () => import('../views/youSheng.vue')
                },
                {//有声读物详情
                    path: "youshengDetail", name: "youshengDetail", component: () => import('../views/youshengDetail.vue')
                },
                {//期刊
                    path: "journal", name: "journal", component: () => import('../views/journal.vue')
                },
                {//在线课程
                    path: "onlineCourse", name: "onlineCourse", component: () => import('../views/onlineCourse.vue')
                },
                {//在线课程详情
                    path: "onlineCourseDetail", name: "onlineCourseDetail", component: () => import('../views/onlineCourseDetail.vue')
                },
                {//主题书单
                    path: "themeBook", name: "themeBook", component: () => import('../views/themeBook.vue')
                },
                {//主题书单更多
                    path: "themeBookSearch", name: "themeBookSearch", component: () => import('../views/themeBookSearch.vue')
                },
                {//我的借阅
                    path: "myBorrow", name: "myBorrow", component: () => import('../views/myBorrow.vue')
                },
                {//个人桌面
                    path: "personalDesktop/:id", name: "personalDesktop", component: () => import('../views/personalDesktop/index.vue')
                },//AI阅读
                {
                    path: "AIReadlist", name: "AIReadlist", component: () => import('../views/AIread/bookList.vue')
                },//征订目录
                {
                    path: "catalogInfo", name: "catalogInfo", component: () => import('../views/catalogInfo.vue')
                },//圣才教辅题库专区
                {
                    path: "catalogInfo", name: "catalogInfo", component: () => import('../views/catalogInfo.vue')
                },//科学文库专区
                {
                    path: "kxwkZone", name: "kxwkZone", component: () => import('../views/kxwkZone.vue')
                },//纸电采选
                {
                    path: "ebookBuy", name: "ebookBuy", component: () => import('../views/ebookBuy.vue')
                },//纸电采选
                {
                    path: "subBook", name: "subBook", component: () => import('../views/subBook.vue')
                },//采选书单
                {
                    path: "buyList", name: "buyList", component: () => import('../views/buyList.vue')
                },
            ]
        },
        {
            path: "404", name: "404", component: () => import('../views/404.vue')
        },  
        {//AI阅读
            path: "/AIread", name: "AIread", component: () => import('../views/AIread/index.vue')
        },  
        { path: "/verificationLottery", name: "verificationLottery", component: () => import('../views/tianjin423/checkOffCode.vue') },
        { path: "/:dircode", name: "LoginByOrg", component: Login },
        // {
        //     path:"/Login",name:"Login",component: () => import('../views/Login.vue')
        // },
    ]
});
router.beforeEach((to, from, next) => {
    //判断访问设备
    var ua = navigator.userAgent;
    const isMobile = !!ua.match(/AppleWebKit.*Mobile.*/);
    if (isMobile) { //如果是移动端
        if(to.params.hasOwnProperty('dircode')){
            window.location.href = 'https://wapready.ytzhihui.com/#/'+to.params.dircode;
            // window.location.href = 'http://192.168.7.99:84/#/'+to.params.dircode;//本地wap H5
            // window.location.href = 'http://yt.gxjsxy.cn:81/#/'+to.params.dircode; //广西建设
            // window.location.href = 'https://172.16.27.150:81/#/'+to.params.dircode; //上海建桥学院图书馆
            // window.location.href = 'https://192.168.116.43:81/#/'+to.params.dircode; //内蒙古科技大学包头师范学院
            // window.location.href = 'https://172.17.1.293:81/#/'+to.params.dircode; //陕西交通职业技术学院图书馆
            // window.location.href = 'https://192.168.8.220:81/#/'+to.params.dircode; //青岛恒星科技学院图书馆
            // window.location.href = 'https://10.8.3.19:81/#/'+to.params.dircode; //锦州医科大学图书馆
        } else if(to.name == 'carsilogin'){ //carsi登陆
            window.location.href = 'https://wapready.ytzhihui.com/#'+to.fullPath;
            // window.location.href = 'http://192.168.7.16:83/#'+to.fullPath;//本地wap H5
            // window.location.href = 'https://172.16.27.150:81/#'+to.fullPath;//上海建桥学院图书馆
            // window.location.href = 'https://192.168.116.43:81/#'+to.fullPath;//内蒙古科技大学包头师范学院
            // window.location.href = 'https://172.17.1.29:81/#'+to.fullPath;//陕西交通职业技术学院图书馆
            // window.location.href = 'https://192.168.8.220:81/#'+to.fullPath;//青岛恒星科技学院图书馆
            // window.location.href = 'https://10.8.3.19:81/#'+to.fullPath;//锦州医科大学图书馆
        } else if(to.name == 'bookDetails'){ //详情
            let index = to.fullPath.indexOf('?');
            window.location.href = 'https://wapready.ytzhihui.com/#/bookDetail'+to.fullPath.substring(index); //线上
            // window.location.href = 'http://192.168.0.134:81/#/bookDetail?'+to.fullPath.substring(index); //广东省食品药品职业技术学校
            // window.location.href = 'http://192.168.100.207:81/#/bookDetail?'+to.fullPath.substring(index); //河南科技大学
            // window.location.href = 'http://192.168.7.26:83/#/bookDetail?'+to.fullPath.substring(index);//本地wap H5
            // window.location.href = 'http://223.2.160.153:81/#/bookDetail?'+to.fullPath.substring(index); //线上
            // window.location.href =  'http://192.168.3.42:81/#/bookDetail?'+to.fullPath.substring(index); //宜州区高级中学
            // window.location.href = 'https://172.16.27.150:81/#/bookDetail?'+to.fullPath.substring(index); //上海建桥学院图书馆
            // window.location.href = 'https://172.16.5.9:81/#/bookDetail?'+to.fullPath.substring(index); //广西建设职业技术学院图书馆
            // window.location.href = 'https://10.215.1.138/#/bookDetail?'+to.fullPath.substring(index); //陕西青年
            // window.location.href = 'https://172.16.1.94/#/bookDetail?'+to.fullPath.substring(index); //漳州卫生职业学院图书馆
            // window.location.href = 'https://172.24.100.171/#/bookDetail?'+to.fullPath.substring(index); //重庆化工职业学院图书馆
            // window.location.href = 'https://192.168.115.190/#/bookDetail?'+to.fullPath.substring(index); //天津渤海职业技术学院图书馆
            // window.location.href = 'https://210.47.221.2/#/bookDetail?'+to.fullPath.substring(index); //辽宁师范大学图书馆
            // window.location.href = 'https://10.100.200.205/#/bookDetail?'+to.fullPath.substring(index); //江西工业贸易职业技术学院图书馆
            // window.location.href = 'https://192.168.116.43/#/bookDetail?'+to.fullPath.substring(index); //内蒙古科技大学包头师范学院
            // window.location.href = 'https://172.17.1.29/#/bookDetail?'+to.fullPath.substring(index); //陕西交通职业技术学院图书馆
            // window.location.href = 'https://192.168.8.220:81/#/'+to.params.dircode; //青岛恒星科技学院图书馆
            // window.location.href = 'https://10.8.3.19:81/#/'+to.params.dircode; //锦州医科大学图书馆
        } else{
            window.location.href = 'https://wapready.ytzhihui.com/#/';
            // window.location.href = 'http://192.168.7.99:83/';//本地wap H5
            // window.location.href = 'http://192.168.0.134:81/#/';//广东省食品药品职业技术学校
            // window.location.href = 'http://192.168.100.207:81/#/'; //河南科技大学
            // window.location.href = 'http://yt.gxjsxy.cn:81/#/'; //广西建设
            // window.location.href = 'http://223.2.160.153:81/#/';//徐州医科大学
            // window.location.href = 'http://192.168.3.42:81/#/'; //宜州区高级中学
            // window.location.href = 'http://192.168.3.42:81/#/';//上海建桥学院图书馆
            // window.location.href = 'http://172.16.5.9:81/#/';//广西建设职业技术学院图书馆
            // window.location.href = 'https://10.215.1.138:81/#/'; //陕西青年
            // window.location.href = 'https://172.16.1.94:81/#/'; //漳州卫生职业学院图书馆
            // window.location.href = 'https://172.24.100.171:81/#/'; //重庆化工职业学院图书馆
            // window.location.href = 'https://192.168.115.190:81/#/'; //天津渤海职业技术学院图书馆
            // window.location.href = 'https://210.47.221.2:81/#/'; //辽宁师范大学图书馆
            // window.location.href = 'https://10.100.200.205:81/#/'; //江西工业贸易职业技术学院图书馆
            // window.location.href = 'https://192.168.116.43:81/#/'; //内蒙古科技大学包头师范学院
            // window.location.href = 'https://172.17.1.29:81/#/'; //陕西交通职业技术学院图书馆
            // window.location.href = 'https://10.8.3.19:81/#/'; //锦州医科大学图书馆
        }
    } else{
        next();
    }
});

// router.beforeEach((to, from, next) => {
//     if (to.matched.some((r) => r.meta.requireAuth)) {
//         console.log(r);
//       let user = JSON.parse(localStorage.getItem('userInfo'));
//       if (user) {   //判断是否已经登录
//         console.log('这是通过拦截后到处理',from);
//         next();
//       } else {
//         next({
//           path: '/Login',
//           query: {redirect: to.fullPath}   //登录成功后重定向到当前页面
//         });
//       }
//     } else {
//       console.log('这是拦截');
//       next();
//     }
//     //如果本地 存在 token 则 不允许直接跳转到 登录页面
//     if(to.fullPath === "/login"){
//       if(localStorage.getItem('user')){
//         next({
//           path:from.fullPath
//         });
//       }else {
//         next();
//       }
//     }
//   });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js